<template>
  <q-form ref="form" @submit="onSubmit">
    <slot></slot>
  </q-form>
</template>

<script>
export default {
  name: 'Form',
  methods: {
    onSubmit(...args) {
      this.$emit('submit', ...args);
    },

    validate() {
      return this.$refs.form.validate();
    },
  },
};
</script>
